'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SELECT_THREAD = exports.SELECT_THREAD = 'SELECT_THREAD';

var CLEAR_SELECTED_THREAD = exports.CLEAR_SELECTED_THREAD = 'CLEAR_SELECTED_THREAD';